export default "__VITE_ASSET__4GYeDnh$__"